import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Button from '../Button';
import Link from '../Link';
import GdaCircleLogo from '../../svg/icons/gda_circle_logo.svg';
import Spacer from '../Spacer';
import TranslationProvider from '../../providers/TranslationProvider';

import './GdaPromotional.scss';

export const PROMOTION_CONTEXT = {
  profile: 'profile', venue: 'venue', event: 'event', default: 'default', concierge: 'concierge',
};

const GdaPromotional = ({
  variant,
  eventPreSaleTiming,
  login,
}) => {
  const [content, setContent] = useState(null);

  const getPromotionalContent = () => {
    const PROMOTIONAL_CONTENT = {
      profile: {
        titleKey: 'introducing_resy_global_access',
        titleContent: 'Global Dining Access by Resy',
        descKey: 'access_to_exclusive_tables',
        descContent: 'Access to exclusive reservations at coveted restaurants around the world. Terms apply.',
        link: '/global-dining-access',
        login: false,
      },
      venue: {
        titleKey: 'introducing_resy_global_access',
        titleContent: 'Global Dining Access by Resy',
        descKey: 'access_to_exclusive_tables',
        descContent: 'Access to exclusive reservations at coveted restaurants around the world. Terms apply.',
        link: '/global-dining-access',
        login: true,
      },
      event: {
        titleKey: 'introducing_resy_global_access_presale',
        titleContent: `Global Dining Access Pre-Sale starts <span>${eventPreSaleTiming?.date} at ${eventPreSaleTiming?.time}</span>`,
        descKey: 'access_to_exclusive_presale',
        descContent: 'Global Dining Access Members receive exclusive pre-sale access to tickets. Eligible Card must be on file to unlock access.',
        link: '/global-dining-access',
        login: true,
      },
      concierge: {
        titleKey: 'introducing_resy_global_concierge',
        titleContent: 'This venue reserves some tables exclusively for Global Dining Access Members.',
        descKey: 'introducing_resy_global_concierge_desc',
        descContent: 'Members can book exclusive reservations by calling the Concierge number on the back of their card.',
        link: '/global-dining-access',
        login: false,
      },
      default: {
        titleKey: 'introducing_resy_global_access',
        titleContent: 'Global Dining Access by Resy',
        descKey: 'access_to_exclusive_tables',
        descContent: 'Access to exclusive reservations at coveted restaurants around the world. Terms apply.',
        link: '/global-dining-access',
        login: true,
      },
    };
    return PROMOTIONAL_CONTENT[variant] || PROMOTIONAL_CONTENT.default;
  };

  useEffect(() => {
    const getContent = getPromotionalContent();
    setContent(getContent);
  }, []);

  const onLogin = () => {
    login();
  };

  if (!content) return null;

  return (
    <div className="GdaPromotional">
      <div className="GdaPromotional__Logo">
        <GdaCircleLogo />
      </div>
      <Spacer width="30" />
      <div className="GdaPromotional__verbiage">
        <div className="GdaPromotional__headline">
          <TranslationProvider className="GdaPromotional__headline-translation" translationKey={content?.titleKey}>
            {content?.titleContent}
          </TranslationProvider>
        </div>

        <TranslationProvider translationKey={content?.descKey}>
          <div className="GdaPromotional__tagline">
            {content?.descContent}
          </div>
        </TranslationProvider>

        <Spacer height="20" />

        <div className="GdaPromotional__ctas">
          <Link
            sm
            variant="gda-button-secondary"
            target="_blank"
            href="http://resy.com/global-dining-access"
          >
            <TranslationProvider translationKey="learn_more">
              <span>Learn More</span>
            </TranslationProvider>
          </Link>

          {(variant === 'concierge')
            && (
              <TranslationProvider translationKey="terms_apply">
                <span className="GdaPromotional__tagline GdaPromotional__terms">
                  Terms apply.
                </span>
              </TranslationProvider>
            )}

          {(content?.login && login)
            && (
            <>
              <Spacer width="20" height="0" as="span" additionalStyles={{ display: 'inline-block' }} />
              <span className="GdaPromotional__login">
                <TranslationProvider translationKey="already_member">
                  <span className="GdaPromotional__member">
                    Already a member?
                  </span>
                </TranslationProvider>

                <Spacer width="10" height="0" as="span" additionalStyles={{ display: 'inline-block' }} />

                <Button onClick={onLogin} variant="no-style" className="GdaPromotional__login-button">
                  <TranslationProvider translationKey="login">
                    <span>Log In</span>
                  </TranslationProvider>
                </Button>
              </span>
            </>
            )}
        </div>
      </div>
    </div>
  );
};

GdaPromotional.propTypes = {
  variant: PropTypes.oneOf([
    'default', // default layout
    'profile', // layout for the reservation tab in account profile
    'venue', // layout for the venue details page
    'event', // layout for the event detail page
    'concierge',
  ]),
  eventPreSaleTiming: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  login: PropTypes.func,
};

GdaPromotional.defaultProps = {
  variant: 'default',
  login: null,
  eventPreSaleTiming: {},
};

GdaPromotional.displayName = 'GdaPromotional';

export default GdaPromotional;
